import React from 'react';
import PropTypes from 'prop-types';
import { Col } from 'react-bootstrap';
import classes from './CallToAction.scss';

const CallToAction = ({ icon, header, content }) => (
  <Col xs={12} sm={4}>
    <div className={classes.align}>
      <div className={classes.icon}>
        {icon}
      </div>
      <div className={classes.header}>
        {header}
      </div>
      <div className={classes.text}>
        {content}
      </div>
    </div>
  </Col>
);
CallToAction.propTypes = {
  icon: PropTypes.node.isRequired,
  header: PropTypes.node.isRequired,
  content: PropTypes.node.isRequired,
};

export default CallToAction;
